var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/encoder.ts
var makeBaseEncoder = /* @__PURE__ */ __name((baseAlphabet) => {
  let n = baseAlphabet.length;
  if (n === 0 || n > 255) {
    throw new Error("Invalid base alphabet length: " + n);
  }
  return {
    encode: /* @__PURE__ */ __name((input) => {
      let flag = 0;
      let leadingZeros = 0;
      let encoding = [];
      for (let byte of input) {
        if (!(flag || byte)) {
          leadingZeros++;
        } else {
          flag = 1;
        }
        let carry = byte;
        for (let i = 0; carry || i < encoding.length; i++) {
          carry += encoding[i] << 8;
          encoding[i] = carry % n;
          carry = carry / n | 0;
        }
      }
      let len = leadingZeros + encoding.length;
      let values = Array(len);
      for (let i = 0; i < len; i++) {
        values[i] = baseAlphabet[i < leadingZeros ? 0 : encoding[len - i - 1]];
      }
      return values.join("");
    }, "encode")
  };
}, "makeBaseEncoder");

// src/decoder.ts
var makeBaseDecoder = /* @__PURE__ */ __name((baseAlphabet) => {
  let n = baseAlphabet.length;
  if (n === 0 || n > 255) {
    throw new Error("Invalid base alphabet length: " + n);
  }
  let map = new Map(
    Array.from(baseAlphabet, (char, i) => [char, i])
  );
  return {
    decode: /* @__PURE__ */ __name((input) => {
      let flag = 0;
      let leadingZeros = 0;
      let decoding = [];
      for (let char of input) {
        let carry = map.get(char);
        if (carry == null) {
          throw new Error("Invalid character: " + char);
        }
        if (!(flag || carry)) {
          leadingZeros++;
        } else {
          flag = 1;
        }
        for (let i = 0; carry || i < decoding.length; i++) {
          carry += decoding[i] * n >>> 0;
          decoding[i] = carry % 256;
          carry = carry / 256 | 0;
        }
      }
      let len = leadingZeros + decoding.length;
      let values = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        values[i] = i < leadingZeros ? 0 : decoding[len - i - 1];
      }
      return values;
    }, "decode")
  };
}, "makeBaseDecoder");
export {
  makeBaseDecoder,
  makeBaseEncoder
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
